<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">文件上传</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div>
          <el-table border v-loading="listLoading" :data="tableData" style="width: 100%">
            <el-table-column prop="name" label="文件类型" width="200" />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="warning" @click="toAdd(scope.row.level)">点击上传</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 添加弹窗 -->
    <Dialog ref="dialog" @submitForm="dialogSure" @closeDialog="closeDialog" :dialogTitle="dialogTitle" :dialogVisible="dialogVisible" :dialogModel="dialogModel" dialogWidth="700px"></Dialog>
  </div>
</template>

<script>
import Dialog from '../../../components/common/Dialog';
import { getBulletinBoardSelect, bulletinBoardPost } from '@/api/first_page.js';

export default {
  components: {
    Dialog,
  },
  data() {
    return {
      listLoading: false,
      tableData: [
        { name: '重要通知', level: 1 },
        { name: '特定通知', level: 2 },
        { name: '部门资料', level: 3 },
      ],
      level: 1,
      dialogVisible: false,
      dialogTitle: '新增',
      gameOptions: [],
      adminOptions: [],
    };
  },
  mounted() {
    this.getSelectList();
  },
  computed: {
    dialogModel() {
      return [
        this.level !== 3 && {
          type: 'el-select',
          label: '游戏',
          prop: 'game_id',
          options: this.gameOptions,
        },
        {
          type: 'el-input',
          label: '标题',
          prop: 'notice_title',
        },
        {
          type: 'el-upload-file-auto',
          label: '上传文件',
          prop: 'content',
        },
        this.level === 2 && {
          type: 'el-select',
          label: '被通知人',
          prop: 'to_admin_id',
          options: this.adminOptions,
          isMultiple: true,
        },
      ];
    },
  },
  methods: {
    // 获取筛选项列表
    async getSelectList() {
      const { data } = await getBulletinBoardSelect();
      if (data.code !== 200) return;
      this.gameOptions = data.data.game;
      this.adminOptions = data.data.admin;
    },
    toAdd(level) {
      this.dialogVisible = true;
      this.level = level;
    },
    // 点击确定
    async dialogSure(form) {
      const obj = Object.assign({ notice_level: this.level, notice_source: 2 }, form);
      const { data } = await bulletinBoardPost(obj);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('操作成功');
      this.closeDialog();
    },
    // 点击关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.dialog.resetForm();
    },
  },
};
</script>
<style>
.el-icon-circle-close:before {
  content: '\E78D';
  position: relative;
  right: 300px;
  top: 290px;
  background-color: white;
}
.filter-item-upload {
  display: inline-block;
  margin: 0px 0px 0px 10px;
  transform: translateY(14px);
}
.el-upload--text {
  width: 80px;
  height: 35px;
  border: none;
}
</style>